import React from 'react';
import { motion } from 'framer-motion';
export function CTASection() {
  return <section id="contact" className="py-20 md:py-32 bg-navy relative overflow-hidden" data-id="element-59">
      {/* Radial Glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-gold/10 rounded-full blur-[100px] pointer-events-none" data-id="element-60" />

      <div className="container mx-auto px-4 md:px-6 relative z-10" data-id="element-61">
        <div className="max-w-3xl mx-auto text-center" data-id="element-62">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-63">
            <h2 className="text-3xl md:text-5xl font-heading font-extrabold text-white mb-6 leading-tight" data-id="element-64">
              Ready to turn happy customers into 5-star reviews?
            </h2>
            <p className="text-lg md:text-xl text-white/80 mb-10 max-w-2xl mx-auto" data-id="element-65">
              Get a free Google audit — we'll show you exactly where you're
              losing customers and how to win them back.
            </p>

            <form className="flex flex-col sm:flex-row gap-3 max-w-lg mx-auto mb-6" onSubmit={e => e.preventDefault()} data-id="element-66">
              <input type="email" placeholder="Enter your email address" required className="flex-grow px-5 py-4 rounded-md bg-white text-ink placeholder:text-gray-400 focus:outline-none focus:ring-2 focus:ring-gold" data-id="element-67" />
              <button type="submit" className="px-8 py-4 bg-gold hover:bg-gold/90 text-navy font-bold rounded-md transition-colors whitespace-nowrap" data-id="element-68">
                Get My Free Audit
              </button>
            </form>

            <p className="text-sm text-white/60" data-id="element-69">
              No credit card. No commitment. Response in 24 hours.
            </p>
          </motion.div>
        </div>
      </div>
    </section>;
}